// Base URL for all API requests
export const BASE_URL = 'https://javapaas-197757-0.cloudclusters.net';
// export const BASE_URL = 'http://localhost:8080';

export const USER_ENDPOINTS = {
    // Authentication Endpoints
    LOGIN: `${BASE_URL}/user/login`,

    // Password Reset Endpoints
    VALIDATE_RESET_TOKEN: `${BASE_URL}/user/validate-reset-token`,
    RESET_PASSWORD: `${BASE_URL}/user/reset-password`,

    // Employee Endpoints
    EMPLOYEE: `${BASE_URL}/employee`,

    //Payments
    PAYMENT: `${BASE_URL}/payment`,
    INBOUND: `${BASE_URL}/payment/inbound`,
    OUTGOING: `${BASE_URL}/payment/outgoing`,
    PAYMENT_CREATE: `${BASE_URL}/payment/create`,
    PAYMENT_UPDATE: `${BASE_URL}/payment/update`,

    // Payroll Endpoints
    PAYROLL: `${BASE_URL}/payroll`,

    //Events endpoints
    CREATE_PERSONAL_EVENT: `${BASE_URL}/event/create/personal`,
    GET_EVENTS: `${BASE_URL}/event`,
    CREATE_CUSTOMER_EVENT: `${BASE_URL}/event/create/customer`,
    UPDATE_EVENT: `${BASE_URL}/event/update`, // For PUT requests
    DELETE_EVENT: `${BASE_URL}/event`, // For DELETE requests, append event ID

    // Event unui client specific după ID și tip eveniment (nou)
    GET_CUSTOMER_EVENTS: `${BASE_URL}/event`, // va fi folosit ca `${GET_CUSTOMER_EVENTS}/${customerId}?eventType=MONTAJ`

    //Customer Endpoints
    CREATE_CUSTOMER: `${BASE_URL}/customer/create`,
    GET_CUSTOMER: `${BASE_URL}/customer`, // va fi folosit ca `${GET_CUSTOMER}/${customerId}`

    // Attachment endpoints - update these
    GET_ATTACHMENTS: `${BASE_URL}/attach`,
    CREATE_ATTACHMENT: `${BASE_URL}/attach`,
    DELETE_ATTACHMENT: `${BASE_URL}/attach`,

    //Review endpoints
    CREATE_UPDATE_REVIEW: `${BASE_URL}/review`,
    GET_CUSTOMER_REVIEW: `${BASE_URL}/review/customer`,
};

// Export individual endpoints for easy destructuring
export const {
    LOGIN,
    VALIDATE_RESET_TOKEN,
    RESET_PASSWORD
} = USER_ENDPOINTS;